var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "automation-block-editor sleep" },
    [
      _c(
        "div",
        { staticClass: "editor-row customize-editor-minimize" },
        [
          _c("div", { staticClass: "editor-row-title" }, [_vm._v("Contact")]),
          _vm._v(" "),
          _c("TiptapEditor", {
            attrs: { placeholder: "Contact", "automation-mode": "" },
            model: {
              value: _vm.clone.contactId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "contactId", $$v)
              },
              expression: "clone.contactId",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.clone.data || [], function (data, dataIndex) {
        return _c(
          "div",
          [
            _c("div", { staticClass: "line" }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "data-header" },
              [
                _c("CustomPicker", {
                  attrs: {
                    items: _vm.methods,
                    idKey: "id",
                    labelKey: "label",
                    title: "Select Action",
                  },
                  model: {
                    value: data.type,
                    callback: function ($$v) {
                      _vm.$set(data, "type", $$v)
                    },
                    expression: "data.type",
                  },
                }),
                _vm._v(" "),
                _vm.clone.data.length > 1
                  ? _c(
                      "SupsisButton",
                      {
                        attrs: { small: "", danger: "" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteData(dataIndex)
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "material-icons" }, [
                          _vm._v("delete"),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm._l(data.payload || [], function (payload, payloadIndex) {
              return _c(
                "div",
                {
                  staticClass:
                    "editor-row customize-editor-minimize data-items",
                },
                [
                  data.type === "addTag" || data.type === "removeTag"
                    ? _c("UpdateTag", {
                        staticStyle: { margin: "10px 0" },
                        attrs: {
                          payload: payload,
                          type: data.type,
                          selectedType: _vm.getSelectedType(payload),
                          isDeleteButtonVisible: data.payload.length > 1,
                        },
                        on: {
                          delete: function ($event) {
                            return _vm.deletePayloadItem(
                              dataIndex,
                              payloadIndex
                            )
                          },
                          save: function ($event) {
                            return _vm.save($event, dataIndex, payloadIndex)
                          },
                        },
                      })
                    : data.type === "updateContactProperty"
                    ? _c("UpdateContactProperty", {
                        key: payloadIndex,
                        staticStyle: { "margin-top": "10px" },
                        attrs: {
                          payload: payload,
                          type: data.type,
                          properties: _vm.properties,
                          idKey: "id",
                          labelKey: "label",
                          title: "Select Action",
                          isDeleteButtonVisible: data.payload.length > 1,
                        },
                        on: {
                          save: function ($event) {
                            return _vm.save($event, dataIndex, payloadIndex)
                          },
                          delete: function ($event) {
                            return _vm.deletePayloadItem(
                              dataIndex,
                              payloadIndex
                            )
                          },
                        },
                      })
                    : _c("UpdateInfo", {
                        key: dataIndex + payloadIndex,
                        staticStyle: { "margin-top": "10px" },
                        attrs: {
                          payload: payload,
                          fields: _vm.fields,
                          idKey: "id",
                          labelKey: "label",
                          title: "Select Action",
                          isDeleteButtonVisible: data.payload.length > 1,
                        },
                        on: {
                          save: function ($event) {
                            return _vm.save($event, dataIndex, payloadIndex)
                          },
                          delete: function ($event) {
                            return _vm.deletePayloadItem(
                              dataIndex,
                              payloadIndex
                            )
                          },
                        },
                      }),
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.isAddPayloadButtonVisible(data)
              ? _c(
                  "SupsisButton",
                  {
                    attrs: { xxsmall: "", ghost: "" },
                    on: {
                      click: function ($event) {
                        return _vm.addPayloadItem(dataIndex)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("add"),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          2
        )
      }),
      _vm._v(" "),
      _vm.clone.data.length !== _vm.methods.length
        ? _c(
            "SupsisButton",
            { attrs: { small: "", ghost: "" }, on: { click: _vm.addDataItem } },
            [_vm._v("Add Method\n    ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "switch" },
        [
          _c("span", { staticClass: "label" }, [_vm._v("Listen event")]),
          _vm._v(" "),
          _c("a-switch", {
            model: {
              value: _vm.clone.isListenEvent,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "isListenEvent", $$v)
              },
              expression: "clone.isListenEvent",
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }